/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import toast from "react-hot-toast";
import {
  MdOutlinePerson,
  MdOutlineLock,
  MdQrCode,
  MdAttachMoney,
  MdCreditCard,
  MdOutlinePhone,
  MdOutlineMail,
  MdOutlineLocationOn,
  MdOutlineInfo,
} from "react-icons/md";
import ClientService from "../../../services/client.service";
import AuthService from "../../../services/auth.service";

const CreateClient = () => {
  const navigate = useNavigate();
  const {state} = useLocation();
  const editItem = state?.item || null;

  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [meta, setMeta] = useState({
    phonecodes: [],
    documentTypes: [],
    states: [],
    cities: [],
  });

  const [form, setForm] = useState({
    code: "",
    name: "",
    tarifa: "",
    email: "",
    lastname: "",
    state_id: "",
    city_id: "",
    phonecode_id: "",
    phone: "",
    document: "",
    document_type_id: "",
    password: "",
    password_confirmation: "",
  });

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      const res = await AuthService.getDocumentTypes({user_id: editItem?.id});
      setMeta((prev) => ({
        ...prev,
        documentTypes: res.document_types || [],
        phonecodes: res.phonecodes || [],
        states: res.states || [],
      }));

      if (res.user) {
        setForm((prev) => ({
          ...prev,
          code: res.user.code || "",
          name: res.user.name || "",
          tarifa: res.user.tarifa ? String(res.user.tarifa) : "",
          email: res.user.email || "",
          lastname: res.user.lastname || "",
          state_id: res.user.state_id ? String(res.user.state_id) : "",
          city_id: res.user.city_id ? String(res.user.city_id) : "",
          phonecode_id: res.user.phonecode_id
            ? String(res.user.phonecode_id)
            : "",
          phone: res.user.phone || "",
          document: res.user.document || "",
          document_type_id: res.user.document_type_id
            ? String(res.user.document_type_id)
            : "",
        }));

        if (res.user.state_id) {
          fetchCities(res.user.state_id, true);
        }
      } else {
        const tarifaRes = await ClientService.admin.getDefaultTarifa();
        if (tarifaRes?.tarifa) {
          setForm((prev) => ({
            ...prev,
            tarifa: String(tarifaRes.tarifa),
          }));
        }
      }
    } catch (error) {
      toast.error("Error al cargar los datos iniciales");
    }
  };

  const fetchCities = async (stateId, withoutLoading = false) => {
    if (!stateId) return;
    try {
      const res = await AuthService.getCities({
        state_id: stateId,
        withoutLoading,
      });
      setMeta((prev) => ({...prev, cities: res.cities || []}));
    } catch (error) {
      toast.error("Error al cargar ciudades");
    }
  };

  const handleChange = (e) => {
    const {name, value} = e.target;

    if (name === "tarifa" && !/^\d*\.?\d{0,2}$/.test(value)) return;
    if ((name === "document" || name === "phone") && !/^\d*$/.test(value))
      return;

    setForm((prev) => ({...prev, [name]: value}));

    if (name === "state_id") {
      setForm((prev) => ({...prev, city_id: ""}));
      fetchCities(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (editItem) {
        await ClientService.admin.update({...form, user_id: editItem.id});
        toast.success("Se ha modificado el cliente correctamente");
      } else {
        await ClientService.admin.create({...form});
        toast.success("Se ha creado el cliente correctamente");
      }
      navigate(-1);
    } catch (error) {
      toast.error("Error al guardar los datos del cliente");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto py-6">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        {/* TABS */}
        <div className="flex border-b border-gray-100 bg-gray-50/50">
          <button
            type="button"
            className={`flex-1 flex items-center justify-center gap-2 py-4 font-semibold text-sm transition-colors ${
              activeTab === 0
                ? "text-[#1D3B8B] border-b-2 border-[#1D3B8B] bg-white"
                : "text-gray-500 hover:text-[#1D3B8B]"
            }`}
            onClick={() => setActiveTab(0)}
          >
            <MdOutlinePerson size={20} />
            DATOS PERSONALES
          </button>
          <button
            type="button"
            className={`flex-1 flex items-center justify-center gap-2 py-4 font-semibold text-sm transition-colors ${
              activeTab === 1
                ? "text-[#1D3B8B] border-b-2 border-[#1D3B8B] bg-white"
                : "text-gray-500 hover:text-[#1D3B8B]"
            }`}
            onClick={() => setActiveTab(1)}
          >
            <MdOutlineLock size={20} />
            SEGURIDAD
          </button>
        </div>

        {/* FORMULARIO */}
        <form onSubmit={handleSubmit} className="p-6 md:p-8">
          {activeTab === 0 && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="col-span-1 md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Código
                  </label>
                  <div className="flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B] focus-within:border-transparent transition-all">
                    <MdQrCode className="text-gray-400 mr-2" size={20} />
                    <input
                      type="text"
                      name="code"
                      value={form.code}
                      onChange={handleChange}
                      placeholder="Código"
                      className="bg-transparent w-full outline-none text-gray-800"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Tarifa ($)
                  </label>
                  <div className="flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B] focus-within:border-transparent transition-all">
                    <MdAttachMoney className="text-gray-400" size={22} />
                    <input
                      type="text"
                      name="tarifa"
                      value={form.tarifa}
                      onChange={handleChange}
                      placeholder="0.00"
                      className="bg-transparent w-full outline-none text-gray-800 ml-1"
                    />
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nombre
                </label>
                <div className="flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B] transition-all">
                  <MdOutlinePerson className="text-gray-400 mr-2" size={20} />
                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Nombre"
                    className="bg-transparent w-full outline-none text-gray-800"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Apellido
                </label>
                <div className="flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B] transition-all">
                  <MdOutlinePerson className="text-gray-400 mr-2" size={20} />
                  <input
                    type="text"
                    name="lastname"
                    value={form.lastname}
                    onChange={handleChange}
                    placeholder="Apellido"
                    className="bg-transparent w-full outline-none text-gray-800"
                  />
                </div>
              </div>

              <div className="col-span-1 md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Cédula o RIF
                </label>
                <div className="flex gap-3">
                  <select
                    name="document_type_id"
                    value={form.document_type_id}
                    onChange={handleChange}
                    className="w-1/3 md:w-1/4 bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 outline-none focus:ring-2 focus:ring-[#1D3B8B] text-gray-800"
                  >
                    <option value="">-</option>
                    {meta.documentTypes.map((i) => (
                      <option key={i.id} value={i.id}>
                        {i.name}
                      </option>
                    ))}
                  </select>
                  <div className="flex-1 flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B] transition-all">
                    <MdCreditCard className="text-gray-400 mr-2" size={20} />
                    <input
                      type="text"
                      name="document"
                      value={form.document}
                      onChange={handleChange}
                      placeholder="Cédula o RIF"
                      className="bg-transparent w-full outline-none text-gray-800"
                    />
                  </div>
                </div>
              </div>

              <div className="col-span-1 md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Teléfono
                </label>
                <div className="flex gap-3">
                  <div className="flex items-center w-1/3 md:w-1/4 bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B]">
                    <MdOutlinePhone className="text-gray-400 mr-1" size={18} />
                    <select
                      name="phonecode_id"
                      value={form.phonecode_id}
                      onChange={handleChange}
                      className="bg-transparent w-full outline-none text-gray-800"
                    >
                      <option value="">-</option>
                      {meta.phonecodes.map((i) => (
                        <option key={i.id} value={i.id}>
                          {i.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="flex-1 flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B]">
                    <MdOutlinePhone className="text-gray-400 mr-2" size={18} />
                    <input
                      type="text"
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      placeholder="Número de teléfono"
                      className="bg-transparent w-full outline-none text-gray-800"
                    />
                  </div>
                </div>
              </div>

              <div className="col-span-1 md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Correo electrónico (Será su usuario)
                </label>
                <div className="flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B] transition-all">
                  <MdOutlineMail className="text-gray-400 mr-2" size={20} />
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="Correo electrónico"
                    className="bg-transparent w-full outline-none text-gray-800"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Estado
                </label>
                <div className="flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B]">
                  <MdOutlineLocationOn
                    className="text-gray-400 mr-2"
                    size={20}
                  />
                  <select
                    name="state_id"
                    value={form.state_id}
                    onChange={handleChange}
                    className="bg-transparent w-full outline-none text-gray-800"
                  >
                    <option value="">Seleccione Estado</option>
                    {meta.states.map((i) => (
                      <option key={i.id} value={i.id}>
                        {i.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Ciudad
                </label>
                <div className="flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B]">
                  <MdOutlineLocationOn
                    className="text-gray-400 mr-2"
                    size={20}
                  />
                  <select
                    name="city_id"
                    value={form.city_id}
                    onChange={handleChange}
                    disabled={!form.state_id}
                    className="bg-transparent w-full outline-none text-gray-800 disabled:text-gray-400"
                  >
                    <option value="">Seleccione Ciudad</option>
                    {meta.cities.map((i) => (
                      <option key={i.id} value={i.id}>
                        {i.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-span-1 md:col-span-2 bg-blue-50/50 border border-blue-100 rounded-xl p-4 flex gap-3 mt-4">
                <MdOutlineInfo
                  className="text-[#1D3B8B] shrink-0 mt-0.5"
                  size={22}
                />
                <div>
                  <h4 className="font-bold text-gray-900 text-sm mb-1">
                    Información importante
                  </h4>
                  <p className="text-sm text-gray-600">
                    Aquí puedes actualizar los datos personales y de contacto
                    del cliente. Para cambiar la contraseña, ve a la pestaña{" "}
                    <b>Seguridad</b>.
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 1 && (
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  {editItem
                    ? "Cambiar contraseña (Opcional)"
                    : "Contraseña de Acceso"}
                </label>
                <div className="flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B]">
                  <MdOutlineLock className="text-gray-400 mr-2" size={20} />
                  <input
                    type="password"
                    name="password"
                    value={form.password}
                    onChange={handleChange}
                    placeholder="Contraseña"
                    className="bg-transparent w-full outline-none text-gray-800"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Repetir contraseña
                </label>
                <div className="flex items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 focus-within:ring-2 focus-within:ring-[#1D3B8B]">
                  <MdOutlineLock className="text-gray-400 mr-2" size={20} />
                  <input
                    type="password"
                    name="password_confirmation"
                    value={form.password_confirmation}
                    onChange={handleChange}
                    placeholder="Repetir contraseña"
                    className="bg-transparent w-full outline-none text-gray-800"
                  />
                </div>
              </div>

              <div className="bg-blue-50/50 border border-blue-100 rounded-xl p-4 flex gap-3 mt-4">
                <MdOutlineInfo
                  className="text-[#1D3B8B] shrink-0 mt-0.5"
                  size={22}
                />
                <div>
                  <h4 className="font-bold text-gray-900 text-sm mb-1">
                    Información importante
                  </h4>
                  <p className="text-sm text-gray-600">
                    Cambie la contraseña solo si es necesario, los campos vacíos
                    no representan un problema.
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="mt-8 flex justify-end">
            <button
              type="submit"
              disabled={loading}
              className="bg-[#1D3B8B] text-white px-8 py-3 rounded-xl font-bold shadow-md hover:bg-[#152a66] transition-colors disabled:opacity-70 disabled:cursor-not-allowed w-full md:w-auto"
            >
              {loading ? "Guardando..." : "Guardar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateClient;
